export { default as TpvFooter } from './TpvFooter';
